import { useMemo } from "react";
import { validationParams } from "../common-dilution/serial-and-co-formulated-dilution/forms/ValidationParamsContext/ValidationParamsWrapper";

export const preDilutionStepDeadVolumeMax = 99999.999;
export const useMastermixValidationParams = () =>
  useMemo(() => ({ ...validationParams, preDilutionStepDeadVolumeMax }), []);
